export default __webpack_public_path__ + "03ac9cd70af4feaa5a9970825365af0b.png";